import { render, staticRenderFns } from "./addWx.vue?vue&type=template&id=5791d240&scoped=true"
import script from "./addWx.vue?vue&type=script&lang=js"
export * from "./addWx.vue?vue&type=script&lang=js"
import style0 from "./addWx.vue?vue&type=style&index=0&id=5791d240&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791d240",
  null
  
)

export default component.exports